var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nav-bar" }, [
    _c(
      "div",
      { staticClass: "ma-logo-icon", on: { click: _vm.handleClickGoToHome } },
      [_c("img", { attrs: { src: _vm.getLogoUrl, height: _vm.getLogoHeight } })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }